import { IApplicationState } from '../../types/redux';

export const selectSelectedId = (state: IApplicationState) => state.folders.selectedId;
